import React, { useEffect, useState } from "react";
import styles from "./Dashpage1.module.scss";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import {
  getAPIKeyAPICall,
  refreshAPIKeyAPICall,
  userDetailsAPICall,
} from "../../../../Shared/APIcalls";
import { Button, IconButton } from "@mui/material";
import { convertNumbertoDate } from "../../../../Shared/CommonFunctions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DoneIcon from "@mui/icons-material/Done";

export default function DashPage1() {
  const [data, setData] = useState({
    ApiKey: "",
    ExpiryDate: "",
    UserID: "",
  });
  const [apikeycopied, setapikeycopied] = useState(false);
  const [vcodecopied, setvcodecopied] = useState(false);

  const [userData, setUserData] = useState({
    request_time: "",
    uname: "",
    m_num: "",
    exarr: ["NFO", "NSE", "BSE", "BFO", "NIPO"],
    prarr: [
      {
        prd: "I",
        s_prdt_ali: "IntraDay",
        exch: ["NSE", "BSE", "NFO", "BFO"],
      },
      {
        prd: "C",
        s_prdt_ali: "Delivery",
        exch: ["NSE", "BSE", "NIPO"],
      },
      {
        prd: "M",
        s_prdt_ali: "Regular",
        exch: ["NFO", "BFO"],
      },
    ],
    orarr: ["MKT", "LMT", "SL-LMT", "SL-MKT", "DS"],
    brkname: "",
    uid: "",
    brnchid: "",
    email: "",
    actid: "",
    uprev: "",
    stat: "",
  });

  useEffect(() => {
    GetAPIKey();
    userDetailsAPICall()
      .then((response: any) => {
        console.log("response", response.data);
        setUserData(response.data);
      })
      .catch((error: any) => {});
  }, []);

  const GetAPIKey = () => {
    getAPIKeyAPICall()
      .then((response: any) => {
        console.log("response", response.data[0]);
        setData(response.data[0]);
      })
      .catch((error: any) => {
        console.log("error", error);
      });
  };

  const handleRefresh = () => {
    refreshAPIKeyAPICall()
      .then((response: any) => {
        GetAPIKey();
      })
      .catch((error: any) => {
        console.log("error", error);
      });
  };

  const handleCreateAPIKey = () => {
    handleRefresh();
  };

  return (
    <div className={styles.mainwrapper}>
      <div className={styles.content}>
        <p className={styles.heading}>Hello, {userData.uname}!</p>
        <p className={styles.para}>Welcome to Firstock Connect</p>
      </div>
      {data.ApiKey !== "0" ? (
        <div className={styles.top}>
          <div className={styles.bottomtop}>
            <p className={styles.details}>API Key Details</p>

            <IconButton onClick={handleRefresh}>
              <AutorenewIcon />
            </IconButton>
          </div>
          <div className={styles.bottomdiv}>
            <div className={styles.main}>
              <div>
                <p className={styles.key}>API Key</p>
              </div>
              <div className={styles.copy1}>
                <p className={styles.numbers}>{data.ApiKey}</p>
                <div>
                  <CopyToClipboard
                    text={data.ApiKey}
                    onCopy={() => {
                      setapikeycopied(true);

                      setTimeout(() => {
                        setapikeycopied(false);
                      }, 4000);
                    }}
                  >
                    {apikeycopied ? (
                      <DoneIcon className={styles.icon} />
                    ) : (
                      <ContentCopyIcon className={styles.icon} />
                    )}
                  </CopyToClipboard>
                </div>
              </div>
            </div>
            <div className={styles.main}>
              <div>
                <p className={styles.key}>Vendor Code</p>
              </div>
              <div className={styles.copy1}>
                <p className={styles.numbers}>{data.UserID}_API</p>
                <CopyToClipboard
                  text={`${data.UserID}_API`}
                  onCopy={() => {
                    setvcodecopied(true);

                    setTimeout(() => {
                      setvcodecopied(false);
                    }, 4000);
                  }}
                >
                  {vcodecopied ? (
                    <DoneIcon className={styles.icon} />
                  ) : (
                    <ContentCopyIcon className={styles.icon} />
                  )}
                </CopyToClipboard>
              </div>
            </div>
            <div className={styles.main}>
              <div>
                <p className={styles.key}>Expiry</p>
              </div>
              <div className={styles.copy1}>
                <p className={styles.numbers}>
                  {convertNumbertoDate(data.ExpiryDate)}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.NoDataGenerateButton}>
          <div className={styles.NoDataGenerateButtonText}>
            Please click on the button to create a new API Key
          </div>

          <Button
            onClick={handleCreateAPIKey}
            type="submit"
            //   fullWidth
            variant="contained"
            sx={{
              borderRadius: "50px",

              mt: 3,
              mb: 2,
              margin: "30px 0px 10px 0",
              padding: "10px 80px",
              backgroundColor: "rgba(109, 0, 255, 1)",
              "&:hover": {
                backgroundColor: "rgba(109, 0, 255, 1)",
              },
            }}
          >
            <span
              style={{
                textTransform: "none",
              }}
            >
              Create New API Key
            </span>
          </Button>
        </div>
      )}
    </div>
  );
}
